import { Box, Typography } from '@mui/material'
import { COLORS, SITE } from '../../constants'

// TODO(Thomas): this is an SVG approximation of the </> "T" mark. When the final logo files are ready,
// drop them in public/brand/ (e.g. logo-mark.svg) and render them here with an <img>. Everything
// else on the site (header, footer, mobile drawer) goes through this component.
export function LogoMark({ size = 40, tone = 'dark' }: { size?: number, tone?: 'dark' | 'light' }) {
    const tFill = tone === 'dark' ? COLORS.white : COLORS.black
    return (
        <svg width={size} height={size * 0.75} viewBox="0 0 64 48" role="img" aria-hidden="true">
            <polygon points="15,11 3,24 15,37 21,37 10,24 21,11" fill={COLORS.accent} />
            <polygon points="49,11 61,24 49,37 43,37 54,24 43,11" fill={COLORS.accent} />
            <polygon points="18,4 50,4 47,12 15,12" fill={tFill} />
            <polygon points="30,12 39,12 33,32 24,32" fill={tFill} />
            <polygon points="24,32 33,32 27,46" fill={COLORS.accent} />
        </svg>
    )
}

type LogoProps = {
    tone?: 'dark' | 'light'
    size?: 'sm' | 'md' | 'lg'
    showTagline?: boolean
}

const SIZES = {
    sm: { mark: 34, text: '1.3rem', tagline: '0.6rem' },
    md: { mark: 46, text: '1.75rem', tagline: '0.68rem' },
    lg: { mark: 72, text: '2.75rem', tagline: '0.8rem' },
}

function Logo({ tone = 'dark', size = 'sm', showTagline = false }: LogoProps) {
    const s = SIZES[size]
    const textColor = tone === 'dark' ? COLORS.white : COLORS.black
    return (
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }} aria-label={SITE.domain}>
            <LogoMark size={s.mark} tone={tone} />
            <Box>
                <Typography
                    component="span"
                    sx={{ display: 'block', fontSize: s.text, fontWeight: 800, letterSpacing: '-0.02em', lineHeight: 1, color: textColor }}
                >
                    tviles<Box component="span" sx={{ color: COLORS.accent }}>.com</Box>
                </Typography>
                {showTagline && (
                    <Typography
                        component="span"
                        sx={{ display: 'block', mt: 0.75, fontSize: s.tagline, letterSpacing: '0.18em', textTransform: 'uppercase', color: tone === 'dark' ? COLORS.mutedOnDark : COLORS.muted }}
                    >
                        {SITE.tagline}
                    </Typography>
                )}
            </Box>
        </Box>
    )
}

export default Logo
